
{
  "familyId": "SPR-KLANK-AA-EE-OO",
  "questions": [
    {
      "id": "SPR-KLANK-AA-EE-OO-001",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "context": "Het meervoud van 'maan'",
      "options": ["manen", "manen", "maanen", "maan'en"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "syllableBlocks", "data": {"word": "manen", "syllables": ["ma", "nen"], "types": ["open", "closed"], "label": "Open lettergreep"}, "showWhen": "wrong"}, {"type": "rule", "data": {"title": "Lange klinker in open lettergreep", "content": "In een open lettergreep (eindigt op klinker) schrijf je de lange klank met één letter: ma-nen (niet maa-nen). De 'aa' wordt 'a' omdat de lettergreep al open is.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_open_lettergreep_aa",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Bij 'maan' → 'manen': de lettergreep 'ma-' is open (eindigt op een klinker). In een open lettergreep schrijf je de lange klank met één letter: 'ma'. Dus: ma-nen, niet maa-nen.",
        "distractorExplanations": {
          "0": "Correct! 'Manen' is juist: open lettergreep 'ma-' → één 'a'.",
          "1": "Dit is hetzelfde als optie A — correct!",
          "2": "Fout: 'maanen' heeft dubbele 'aa' in een open lettergreep. In een open lettergreep schrijf je de lange klank met één letter: ma-nen.",
          "3": "Fout: apostroffen gebruik je niet bij meervouden van woorden die op een medeklinker eindigen. Het meervoud is gewoon 'manen'."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-002",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct voor het meervoud van 'boom'?",
      "context": null,
      "options": ["bomen", "boomen", "boom'en", "bomen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "syllableBlocks", "data": {"word": "bomen", "syllables": ["bo", "men"], "types": ["open", "closed"], "label": "Open lettergreep"}, "showWhen": "wrong"}, {"type": "rule", "data": {"title": "Lange klinker: oo → o", "content": "boom → bo-men: de lettergreep 'bo-' is open. In een open lettergreep schrijf je de lange 'oo' als één 'o'. Dus: bo-men, niet boo-men.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_open_lettergreep_oo",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "boom → bomen: de lettergreep 'bo-' is open (eindigt op een klinker). In een open lettergreep schrijf je de lange 'oo' als één 'o'. Dus: bo-men, niet boo-men.",
        "distractorExplanations": {
          "0": "Correct! 'Bomen' is juist: open lettergreep 'bo-' → één 'o'.",
          "1": "Fout: 'boomen' heeft dubbele 'oo' in een open lettergreep. In een open lettergreep schrijf je de lange klank met één letter: bo-men.",
          "2": "Fout: apostroffen gebruik je niet bij dit soort meervouden. Het meervoud is gewoon 'bomen'.",
          "3": "Dit is hetzelfde als optie A — correct!"
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-003",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "context": "Het meervoud van 'reet' (= spleet)",
      "options": ["reten", "reeten", "reten", "reet'en"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Lange klinker: ee → e", "content": "reet → re-ten: de lettergreep 're-' is open. In een open lettergreep schrijf je de lange 'ee' als één 'e'. Dus: re-ten, niet ree-ten.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_open_lettergreep_ee",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "reet → reten: de lettergreep 're-' is open. In een open lettergreep schrijf je de lange 'ee' als één 'e'. Dus: re-ten, niet ree-ten.",
        "distractorExplanations": {
          "0": "Correct! 'Reten' is juist: open lettergreep 're-' → één 'e'.",
          "1": "Fout: 'reeten' heeft dubbele 'ee' in een open lettergreep. In een open lettergreep schrijf je de lange klank met één letter: re-ten.",
          "2": "Dit is hetzelfde als optie A — correct!",
          "3": "Fout: apostroffen gebruik je niet bij dit soort meervouden."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-004",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "context": null,
      "options": [
        "De bomen in het bos zijn heel groot.",
        "De boomen in het bos zijn heel groot.",
        "De bomen in het boos zijn heel groot.",
        "De bomen in het bos zijn heel grroot."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Lange klinker in open lettergreep", "content": "boom → bo-men (open lettergreep: één 'o')\nbos → bos (gesloten lettergreep: korte 'o', blijft 'o')\ngrroot bestaat niet — 'groot' heeft een gesloten lettergreep", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_zin_correct",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "De correcte zin is: 'De bomen in het bos zijn heel groot.' — bomen (open lettergreep: bo-men), bos (gesloten lettergreep, korte 'o'), groot (gesloten lettergreep, lange 'oo' blijft 'oo').",
        "distractorExplanations": {
          "0": "Correct! Alle woorden zijn juist gespeld.",
          "1": "Fout: 'boomen' is fout. Open lettergreep 'bo-' → één 'o': bomen.",
          "2": "Fout: 'boos' betekent 'kwaad'. Het woord 'bos' (= forest) heeft een korte 'o' en een gesloten lettergreep.",
          "3": "Fout: 'grroot' bestaat niet. 'Groot' heeft een gesloten lettergreep met lange 'oo'."
        }
      }
    },
    {
      "id": "SPR-KLANK-AA-EE-OO-005",
      "familyId": "SPR-KLANK-AA-EE-OO",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_lange_klinkers",
      "questionType": "multiple_choice",
      "question": "Welke regel is JUIST?",
      "context": null,
      "options": [
        "In een open lettergreep schrijf je een lange klinker met één letter (aa→a, ee→e, oo→o).",
        "In een open lettergreep schrijf je altijd twee klinkers naast elkaar.",
        "In een gesloten lettergreep schrijf je een lange klinker met één letter.",
        "Lange klinkers schrijf je altijd dubbel (aa, ee, oo)."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "De regel samengevat", "content": "Open lettergreep (eindigt op klinker) → lange klank met één letter: ma-nen, bo-men, re-ten\nGesloten lettergreep (eindigt op medeklinker) → lange klank met twee letters: maan, boom, reet", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "lange_klinker_regel_samenvatting",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "De regel: in een OPEN lettergreep (eindigt op klinker) schrijf je de lange klank met één letter. Voorbeelden: maan → ma-nen, boom → bo-men. In een GESLOTEN lettergreep (eindigt op medeklinker) schrijf je de lange klank met twee letters: maan, boom.",
        "distractorExplanations": {
          "0": "Correct! In een open lettergreep schrijf je de lange klank met één letter.",
          "1": "Fout: in een open lettergreep schrijf je juist één klinker (niet twee). Twee klinkers gebruik je in een gesloten lettergreep.",
          "2": "Fout: in een GESLOTEN lettergreep schrijf je de lange klank met twee letters (aa, ee, oo). In een OPEN lettergreep gebruik je één letter.",
          "3": "Fout: lange klinkers schrijf je alleen dubbel in een gesloten lettergreep (maan, boom). In een open lettergreep schrijf je ze enkel (ma-nen, bo-men)."
        }
      }
    }
  ]
}
